import { useContext, useMemo } from "react";
import { indexBy, prop } from "ramda";
import { getComments } from "../requests";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import GuestbookContext from "../context/GuestbookContext";

export const useComments = () => {
  const {guestbookKey} = useContext(GuestbookContext)
  const queryClient = useQueryClient()
  const {data, isLoading} = useQuery({
    queryKey: ["comments", guestbookKey],
    queryFn: () => getComments(guestbookKey).then(({items}) => items),
    placeholderData: [],
    enabled: !!guestbookKey,
    staleTime: Infinity,
  })

  const invalidate = () => {
    void queryClient.invalidateQueries({
      queryKey: ["comments", guestbookKey],
    })
  }

  const byId = useMemo(() => indexBy(prop("id"), data), [data])
  const allIds = useMemo(() => data.map(prop("id")), [data])
  const addComment = (newComment) => {
    queryClient.setQueryData(["comments", guestbookKey], (oldData) => [
      newComment,
      ...oldData,
    ])
  }

  const mutateComment = (commentId, updateFn) => {
    queryClient.setQueryData(["comments", guestbookKey], (oldData) =>
      oldData.map((c) => (c.id === commentId ? updateFn(c) : c))
    )
  }

  return {byId, allIds, addComment, isLoading, mutateComment, invalidate};
}

